import React from 'react';
import { images, steps } from '../mock';

const HowItWorks = () => {
  return (
    <section id="how" className="bg-[#f8f4ec] py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5 fade-up">
            <div className="eyebrow label-caps mb-6">How it works</div>
            <h2 className="font-serif text-[#201d1a] text-[36px] md:text-[52px] leading-[1.06] tracking-tight">
              A simple, honest way of working together.
            </h2>
            <p className="mt-6 text-[16px] leading-[1.7] text-[#4a423b] max-w-[440px]">
              No long lock-ins or costly retainers. Just a clear, flexible contract shaped around what your business actually needs.
            </p>
            <div className="mt-10 image-frame aspect-[4/5] w-full max-w-[260px] sm:max-w-[300px] mx-auto lg:mx-0 lg:max-w-[340px]">
              <img
                src={images.plans}
                alt="A calm, frosty New Zealand river winding through native bush"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:col-span-7 fade-up">
            <div className="border-t border-[#d9d0c1]">
              {steps.map((step) => (
                <div
                  key={step.numeral}
                  className="grid grid-cols-[90px_1fr] gap-6 py-9 border-b border-[#d9d0c1] group"
                >
                  <div className="label-caps text-[#a4514a] pt-2 group-hover:text-[#8f4640] transition-colors">
                    {step.numeral}
                  </div>
                  <div>
                    <h3 className="font-serif text-[#201d1a] text-[24px] leading-tight">
                      {step.title}
                    </h3>
                    <p className="mt-3 text-[15px] leading-[1.75] text-[#5b524a] max-w-[520px]">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
